import React, {ReactNode} from "react"

import {cn} from "@/lib/utils"

type PageProps = {
    children: ReactNode
    className?: string
}

const Page: React.FC<PageProps> = ({children, className}) => {
    return <div className={cn("flex flex-col w-full h-full justify-between", className)}>{children}</div>
}

export default Page
